export const MAX_CORNER_RADIUS = 3e38
export const MAX_CORNER_CSS_VALUE = 'calc(infinity * 1px)'

export const isMaxCornerRadius = (value: number) => value >= MAX_CORNER_RADIUS

export const hasUniformCornerRadius = (radius: number[]) =>
  radius.every(r => r === radius[0]) || radius.every(isMaxCornerRadius)
